import "../ReusableComponent/CIVIL/CivilBatchSection/CivilBatch.css";
// E: \Tech - Xtend\Insight_Projects\UserPanel\Raaz_Work_Insight\src\jsx\ReusableComponent\CIVIL\CivilBatchSection\CivilBatch.css
import 'bootstrap/dist/css/bootstrap.min.css';
import { BsCalendar2Week, BsCardChecklist, BsPersonWorkspace } from "react-icons/bs";
import { FaFacebook, FaRupeeSign, FaTelegram, FaWhatsapp, FaYoutube } from "react-icons/fa";
import { IoLogoAndroid } from "react-icons/io";
import { MdOutlineFileDownload } from "react-icons/md";
import { Link, useLocation } from 'react-router-dom';
// import CivilModal from '../CivilModal/CivilModal';
import 'animate.css';

const BookUpperSection = ({ bookData }) => {
    console.log("BookUpperSection bookData:", bookData);
    const { admissionStartDate, appDiscount, courseId, currentBatchID, demoVideoLink, description, discount, duration, examType, examTypeId, faculty, facultyId, imageURL, metaDescription, metaTitle, pdfURL, price, sNo, seatBookingPrice, startDate, subscriptionCount, syllabusPDFURL, tags, title, topicCount, topics, type, typeId } = bookData;
    const location = useLocation();
    // return<></>;
    return (
        <>
            {bookData && <div className='CivilBatch-row laptop-view'>
                <div className='col-lg-8 col-md-6 col-sm-12'>
                    <div className='row'>
                        <h1 className='fs-3 text-white d-flex justify-content-between'>{title}</h1>
                        <hr className='text-white' />
                    </div>
                    <div className='row'>
                        <div className='col-lg-4 col-md-4 col-sm-4 text-center p-3'>
                            <BsCalendar2Week className='text-white icon-size mb-2' />
                            <h5 className='text-white fs-6'>PRACTICE QUIZ</h5>
                        </div>
                        <div className='col-lg-4 col-md-4 col-sm-4 text-center p-3'>
                            <BsPersonWorkspace className='text-white icon-size mb-2' />
                            <h5 className='text-white fs-6'>Previous Year Qs.</h5>
                        </div>
                        <div className='col-lg-4 col-md-4 col-sm-4 text-center p-3'>
                            <BsCardChecklist className='text-white icon-size mb-2' />
                            <h5 className='text-white fs-6'>{topicCount} LESSONS</h5>
                        </div>
                    </div>
                    <div className='row py-0'>
                        <p className='text-white renderhtml' dangerouslySetInnerHTML={{ __html: description }} />
                        <ul className='d-flex justify-content-bewteen'>
                            <li className='list-group-item m-1 my-0'>
                                <Link className='list-group-item bg-primary p-2 text-white fs-5 d-flex justify-content-center rounded-circle'>
                                    <FaFacebook />
                                </Link>
                            </li>
                            <li className='list-group-item m-1 my-0'>
                                <Link className='list-group-item bg-success p-2 text-white fs-5 d-flex justify-content-center rounded-circle'>
                                    <FaWhatsapp />
                                </Link>
                            </li>
                            <li className='list-group-item m-1 my-0'>
                                <Link className='list-group-item bg-danger p-2 text-white fs-5 d-flex justify-content-center rounded-circle'>
                                    <FaYoutube />
                                </Link>
                            </li>
                            <li className='list-group-item m-1 my-0'>
                                <Link className='list-group-item bg-primary p-2 text-white fs-5 d-flex justify-content-center rounded-circle'>
                                    <FaTelegram />
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className='row'>

                    </div>
                </div>
                <div className='col-lg-3 col-md-6 col-sm-12'>
                    <div className='d-grid pb-2'>
                        <img src={imageURL} className="batch-img" alt='...' />
                    </div>

                </div>
            </div>}

            {
                bookData && <div className='CivilBatch-row phone-view'>
                    <div className='col-lg-12 col-md-12 col-sm-12'>
                        <div className='pb-2'>
                            <img src={imageURL} className="batch-img" alt='...' />
                        </div>
                        <div className='row py-1'>
                            <h1 className='fs-3 text-white d-flex justify-content-between'>{title}</h1>
                            <hr className='text-white' />
                        </div>
                        <div className='py-3 general-icon-container'>
                            <div className='col-lg-4 text-center p-3'>
                                <BsCalendar2Week className='text-white icon-size mb-2' />
                                <h6 className='text-white'>PRACTICE QUIZ</h6>
                            </div>
                            <div className='col-lg-4 text-center p-3'>
                                <BsPersonWorkspace className='text-white icon-size mb-2' />
                                <h5 className='text-white fs-6'>Previous Year Qs.</h5>
                            </div>
                            <div className='col-lg-4 text-center p-3'>
                                <BsCardChecklist className='text-white icon-size mb-2' />
                                <h6 className='text-white'>{topicCount} LESSONS</h6>
                            </div>
                        </div>
                        {/* <div className='row py-1'>
                            <div className="d-grid gap-3">
                                {
                                    isEnrolled == 'enrolled' ?
                                        <Link className="btn bg-orange fw-bold fs-6 p-2" to="#" type="button">ENROLLED</Link> : (
                                            storedAuthToken ?
                                                <button className="btn bg-orange fw-bold fs-6 p-2" to="#" onClick={handleEnroll} type="button"><FaRupeeSign /> {displayPrice} {displayPrice < 1 ? 'ENROLL FOR FREE' : 'ENROLL'}</button>
                                                :
                                                <button className="btn bg-orange fw-bold fs-6 p-2" onClick={() => navigate('/login', { state: { from: location.pathname } })
                                                } to="/login" state={{ from: location.pathname }} type="button"><FaRupeeSign /> {displayPrice} {displayPrice < 1 ? 'ENROLL FOR FREE' : 'ENROLL'}</button>
                                        )
                                }

                                {storedAuthToken && isEnrolled == 'enrolled' && <Link className="btn bg-orange fw-bold fs-6 p-2" to="https://docs.google.com/forms/d/e/1FAIpQLSfSUAiaT0CT2jfaqJ6hRZgaVDlqd72RyqL62KhpGFfng7hpsg/viewform?usp=sf_link " type="button">BOOK DELIVERY ADDRESS</Link>}
                            </div>
                        </div> */}
                        {/* <div className='row py-1'>
                            <div className="d-grid gap-2">
                                <button disabled={!SyllabusPdf} className="btn bg-orange fw-bold fs-6 p-2" type="button" onClick={() => window.open(SyllabusPdf, '_blank')} ><MdOutlineFileDownload className='fw-bold mb-1 fs-5' />Download Syllabus</button>
                                <Link className="btn bg-purple fw-bold fs-6 p-2" to="#" onClick={openModal} type="button"><IoLogoAndroid className='fw-bold mb-1 fs-5' />Download App</Link>

                                {(isEnrolled != 'enrolled' && VideoId) ?
                                    (storedAuthToken ?
                                        <Link className="btn bg-orange fw-bold fs-6 p-2" to="#" onClick={openModal1} type="button"><BsPersonWorkspace className='fw-bold mb-1 fs-5' /> Demo Class</Link>
                                        :
                                        <Link className="btn bg-orange fw-bold fs-6 p-2" to="/login" state={{ from: location.pathname }} type="button"><BsPersonWorkspace className='fw-bold mb-1 fs-5' /> Demo Class</Link>
                                    )
                                    : null
                                }
                                <Link className="btn bg-green fw-bold fs-6 p-2" to="https://api.whatsapp.com/send?phone=919821333936" target='_blank' type="button"><FaWhatsapp className='fw-bold mb-1 fs-5' />982 133 3936</Link>
                            </div>
                        </div> */}

                        {/* <div className='row'>
                            {isEnrolled != 'enrolled' && (Discount !== 0 ? <h1 className='text-white ps-2 fs-2'> <FaRupeeSign className='fs-2' />{displayPrice}<b className='fs-5 fw-normal px-2 text-decoration-line-through'><FaRupeeSign className='fs-5' />{Price}</b><span className='text-white fs-5 px-0'>{Discount}% off</span></h1> : <h1 className='text-white fs-2'><FaRupeeSign /> {displayPrice}</h1>)}
                        </div> */}
                        <div className='row py-2'>
                            {<p className='text-white renderhtml' dangerouslySetInnerHTML={{ __html: description }} />}
                        </div>
                        <div className='row'>
                            <ul className='d-flex justify-content-bewteen'>
                                <li className='list-group-item m-1 my-0'>
                                    <Link className='list-group-item bg-primary p-2 text-white fs-5 d-flex justify-content-center rounded-circle'>
                                        <FaFacebook />
                                    </Link>
                                </li>
                                <li className='list-group-item m-1 my-0'>
                                    <Link className='list-group-item bg-success p-2 text-white fs-5 d-flex justify-content-center rounded-circle'>
                                        <FaWhatsapp />
                                    </Link>
                                </li>
                                <li className='list-group-item m-1 my-0'>
                                    <Link className='list-group-item bg-danger p-2 text-white fs-5 d-flex justify-content-center rounded-circle'>
                                        <FaYoutube />
                                    </Link>
                                </li>
                                <li className='list-group-item m-1 my-0'>
                                    <Link className='list-group-item bg-primary p-2 text-white fs-5 d-flex justify-content-center rounded-circle'>
                                        <FaTelegram />
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            }

           
        </>
    )
}

export default BookUpperSection